import { computed } from 'vue'
import { mapMutations } from 'vuex'

export default {
  provide() {
    return {
      isMobile: computed(() => this.isMobile),
    }
  },
  data() {
    return {
      isMobile: false,
    }
  },
  methods: {
    ...mapMutations('common', ['setIsMobileState']),

    checkIsMobile() {
      const userAgent = navigator.userAgent.toLowerCase()

      const hasCursor = window.matchMedia('(pointer:fine)').matches
      const hasMultiTouch = navigator.maxTouchPoints > 0
      const isMobile = /mobile|android|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(userAgent)

      return (
        isMobile ||
        (!hasCursor && hasMultiTouch) ||
        window.matchMedia(`(max-width: ${window.config.mobileBP}px)`).matches
      )
    },

    setupIsMobile() {
      this.updateIsMobile()

      addEventListener('resize', (event) => {
        this.updateIsMobile()
      })
      addEventListener('orientationchange', (event) => {
        this.updateIsMobile()
      })
    },

    updateIsMobile() {
      document.body.classList.remove('body-mobile')
      document.body.classList.remove('body-desktop')

      this.isMobile = this.checkIsMobile()
      this.setIsMobileState(this.isMobile)

      if (this.isMobile) {
        document.body.classList.add('body-mobile')
      } else {
        document.body.classList.add('body-desktop')
      }
    },
  },
}
